export default "__VITE_ASSET__Gpjrs2Bb__"